import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { sutConnections } from '../../docs-routes'

const SUTs = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      You need connections to systems under test (SUTs) to execute your tests.
    </Color>
    <DocusaurusFooter path={sutConnections} />
  </Paragraph>

export default SUTs
